import { combineRoutes, composeRoute } from '../lib'
import { configurationRoutes } from './configuration'

const indexRoute = composeRoute({
  id: 'index',
  route: '/index',
  make: () => '/' as const,
})

const bridgeRoute = composeRoute({
  id: 'bridge',
  route: '/bridge',
  make: () => '/bridge' as const,
})

const landingRoute = composeRoute({
  id: 'landing',
  route: '/landing',
  make: () => '/landing' as const,
})

const setupRoute = composeRoute({
  id: 'setup',
  route: '/setup',
  make: () => '/setup' as const,
})

export const allRoutes = [indexRoute, bridgeRoute, landingRoute, setupRoute, ...configurationRoutes] as const

export const appRoutes = combineRoutes(allRoutes)
